import { Building2, Factory, Car, Ship, Train, Wrench } from 'lucide-react';
import { industries } from '../mock';

const iconMap = { Building2, Factory, Car, Ship, Train, Wrench };

export default function IndustriesSection() {
  return (
    <section className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 items-end mb-14">
          <div className="lg:col-span-7">
            <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-amber-600 mb-4">
              — Industries We Power
            </div>
            <h2 className="font-display text-4xl lg:text-5xl font-semibold text-[#0b0b0d] leading-[1.05]">
              From skyscrapers to shipyards —
              <span className="text-neutral-500"> our rods hold India together.</span>
            </h2>
          </div>
          <p className="lg:col-span-5 text-neutral-600 leading-relaxed">
            Prakash Electrodes Private Limited supplies the demanding sectors that define
            India&rsquo;s industrial backbone. Every rod we ship is field-tested for the
            environments it&rsquo;s built for.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {industries.map((ind) => {
            const Icon = iconMap[ind.icon] || Building2;
            return (
              <div
                key={ind.name}
                className="card-lift group relative rounded-2xl overflow-hidden aspect-[5/4] cursor-pointer"
              >
                <img
                  src={ind.image}
                  alt={ind.name}
                  className="absolute inset-0 h-full w-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0b0b0d] via-[#0b0b0d]/50 to-transparent" />
                <div className="absolute inset-0 bg-[#0b0b0d]/10 group-hover:bg-amber-500/10 transition-colors" />
                <div className="absolute top-5 left-5 h-10 w-10 rounded-lg bg-white/10 backdrop-blur border border-white/20 flex items-center justify-center">
                  <Icon className="h-5 w-5 text-amber-400" />
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <h3 className="font-display text-xl font-semibold">{ind.name}</h3>
                  <p className="text-sm text-white/70 mt-1">{ind.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
